import { useDispatch } from "react-redux";
import { Route, useRouteMatch } from "react-router-dom";
import { push } from "connected-react-router";
import React from "react";
import { Switch } from "react-router";
import SubmitQrCodeModal from "widgets/modals/qr-codes/SubmitQrCodeModal";
import { SUBMIT_QR_MODES } from "utils/constants";

export default function Modals({ libraryId, designId, previewImageUrl, onSuccess }) {
	const dispatch = useDispatch();
	let { path, url } = useRouteMatch();

	function onCloseModal() {
		dispatch(push(`${url}/`));
	}

	return (
		<Switch>
			<Route
				exact
				path   = {`${path}modal/submit-qr-code/`}
				render = {(routeRenderProps) => {
					return (
						<SubmitQrCodeModal
							{...routeRenderProps}
							libraryId = {parseInt(libraryId)}
							designId = {parseInt(designId)}
							previewImageUrl = {previewImageUrl}
							onClose = {onCloseModal}
							onSuccess = {onSuccess}
							mode = {SUBMIT_QR_MODES.CREATE}
						/>
					);
				}}
			/>
			<Route
				exact
				path   = {`${path}modal/submit-qr-code/qr-code/:idQrCode/`}
				render = {() => {
					return (
						<SubmitQrCodeModal
							libraryId = {parseInt(libraryId)}
							designId = {parseInt(designId)}
							previewImageUrl = {previewImageUrl}
							onClose = {onCloseModal}
							onSuccess = {onSuccess}
							mode = {SUBMIT_QR_MODES.EDIT}
						/>
					);
				}}
			/>
			<Route
				exact
				path   = {`${path}modal/submit-qr-code/qr-code/:idQrCode/duplicate/`}
				render = {() => {
					return (
						<SubmitQrCodeModal
							libraryId = {parseInt(libraryId)}
							designId = {parseInt(designId)}
							previewImageUrl = {previewImageUrl}
							onClose = {onCloseModal}
							onSuccess = {onSuccess}
							mode = {SUBMIT_QR_MODES.DUPLICATE}
						/>
					);
				}}
			/>
		</Switch>
	);
}

Modals.displayName = "Modals";
